<template>
  <div v-loading="loading">
    <login-header v-bind="headerInfo" @listenToChildEvent="showMsgFromChild"></login-header>
    <div class="content">
      <div class="zc-box zh-box">
        <div style="height: 50px"></div>
        <el-form ref="form" :model="form" label-width="150px" class="dl-list">
          <el-form-item>
            <span slot="label"><span style="color: #f00">* </span>店铺名称：</span>
            <el-input v-model="form.storeName" placeholder="请填写店铺名称"></el-input>
          </el-form-item>
          <el-form-item style="margin: -22px 0 0;">
            <span slot="label"></span>
            <span>建议店铺名称设置在10字以内，名称过长会导致小程序端显示不全</span>
          </el-form-item>
          <el-form-item>
            <span slot="label"><span style="color: #f00">* </span>店铺行业分类：</span>
            <el-select v-model="value" placeholder="请选择" class="inputWidth">
              <el-option
                v-for="item in categorys"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="姓名：">
            <el-input class="inputWidth" v-model="form.name" placeholder="请填写姓名"></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">
              <span style="color: #f00" v-if="type_id==6 || type_id==3"> * </span>区域（省市区）：</span>
            <el-cascader
                        class="selected"
                         expand-trigger="hover"
                         :options="region"
                         v-model="selectedRegion">
            </el-cascader>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="form.details" placeholder="请填写具体地址"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="yellow-btn" @click="createNow">立即创建</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <login-footer :description="desc"></login-footer>

  </div>
</template>
<script>

// 创建店铺页面

import loginHeader from '../header'
import loginFooter from '../footer'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'create-store',
  components: {
    loginHeader,
    loginFooter
  },
  data() {
    return {
      loading: false,
      headerInfo: {
        type: '创建店铺',
        userDisplayFlag: true,
        userName: '',
        logo: ''
      },
      desc: '',
      storeInfo: {},
      form: {
        storeName: ''
      },
      options: [],
      selects: [],
      value: '',
      categorys: [],
      type_id: '',
      selectedRegion: [], // 地区已选择值
      region: [], // 地区
      province_id: '',
      city_id: '',
      area_id: '',
      industry_id: ''

    }
  },
  methods: {
    showMsgFromChild(data, loadingData) {
      var that = this
      that.loading = loadingData
      setTimeout(() => {
        that.loading = false
        that.headerInfo.userDisplayFlag = data
        localStorage.setItem('mobile', '')
        localStorage.setItem('mytoken', '')
        that.$router.push({ path: `/login.html` })
      }, 500)
    },
    createNow() {
      var that = this
      QM.apinew({
        url: '/seller/store/create',
        method: 'post',
        data: {
          name: that.form.storeName,
          industry_id: that.value,
          type_id: that.type_id,
          province_id: that.selectedRegion[0],
          city_id: that.selectedRegion[1],
          area_id: that.selectedRegion[2],
          owner: that.form.name,
          street: that.form.details
        },
        success: function (xdata) {
          that.loading = true
          that.$router.push({ path: `/index.html` })
          that.loading = false
          that.$message({
            message: xdata.message,
            type: 'success'
          })
        },
        error: function (xdata) {
          if (that.form.storeName == '') {
            that.$message.error('请填写店铺名称')
          } else if (that.value == '') {
            that.$message.error('请选择店铺行业分类')
          } else if (that.type_id == 6 && that.selectedRegion.length == 0) {
            that.$message.error('请选择区域')
          } else {
            that.$message.error(xdata.message)
          }
        }
      })
    },

    getCategory() {
      var that = this
      QM.apinew({
        url: '/seller/industry/list',
        method: 'get',
        data: {
          type_id: this.type_id
        },
        success: function (xdata) {
          that.categorys = xdata.data.map(item => {
            return {
              value: item.id,
              label: item.name
            }
          })
        },
        error: function (xdata) {
        }
      })
    },
    getRegion() {
      axios
        .get('/static/js/region.json')
        .then(res => {
          // this.isLoading = false
          this.region = res.data
          // 设置地区默认值
          // this.selectedRegion = this.setRegionDefalut();
        })
        .catch(err => {
          this.$message.error(err)
        })
    }
    // 设置地区默认值
    // setRegionDefalut() {
    //   var arr = [];
    //   arr.push(this.province_id);
    //   arr.push(this.city_id);
    //   arr.push(this.area_id);
    //   return arr;
    //
    // },
  },
  created() {
    //   document.title=localStorage.getItem("title")
    this.loginInfo = qs.parse(localStorage.getItem('xdata'))
    this.headerInfo.logo = this.loginInfo.logo
    this.desc = this.loginInfo.desc
  },
  mounted() {
    this.type_id = this.$route.params.id
    this.getCategory()
    var mobile = localStorage.getItem('mobile')
    this.headerInfo.userName = mobile
    this.getRegion()
  }
}
</script>

<style scoped>
  .zc-box {
    width: 580px;
  }

  .yellow-btn {
    width: 390px;
    line-height: initial;
  }
  .inputWidth{
      width: 200px;
  }
  .selected{
      width: 100%;
  }
</style>